import { TranslationsService } from "appworks/services/translations/translations-service";
import { gameiomModel } from "gameiom/model/gameiom-model";

export class AgsTranslationsService extends TranslationsService {
    public get(id: string, parameters?: { [value: string]: string | number }): string {
        let translationKey = id;

        if (this.aliases.has(id.toLowerCase())) {
            translationKey = this.aliases.get(id.toLowerCase());
        }

        if (gameiomModel.isSocial) {
            const tknKey = `${translationKey.toLowerCase()}_tkn`;
            if(translationKey.includes("_currency")) {
                translationKey = translationKey.replace("_currency", "");
            }
            else if (this.translations.has(tknKey)) {
                translationKey = tknKey;
            }
        }

        if (gameiomModel.hideJackpotWording) {
            const noJackpotKey = `${translationKey.toLowerCase()}_no_jackpot`;
            if (this.translations.has(noJackpotKey)) {
                translationKey = noJackpotKey;
            }
        }

        return super.get(translationKey, parameters);
    }
}
